import React from 'react';
import AttractionCard from '../AttractionCard';
import './styles.css';

const AttractionsList = ({ attractions }) => {
    return (
        <div>
            <h3 className="attractions-header">Recommended Things to Do:</h3>
            <div className="box flex-container">
                {
                    attractions.map((attraction) => {
                        return (
                            <AttractionCard {...attraction} key={attraction.name} />
                        )
                    })
                }
            </div>
        </div>
    );
};

export default AttractionsList;
